import { usePaymentStore } from '@/infrastructure/store/paymentStore';

export const usePayment = () => {
  const availableMethods = usePaymentStore((s) => s.availableMethods);
  const currentIntent = usePaymentStore((s) => s.currentIntent);
  const paymentHistory = usePaymentStore((s) => s.paymentHistory);
  const step = usePaymentStore((s) => s.step);
  const selectedProvider = usePaymentStore((s) => s.selectedProvider);
  const isLoading = usePaymentStore((s) => s.isLoading);
  const error = usePaymentStore((s) => s.error);
  const fetchAvailableMethods = usePaymentStore((s) => s.fetchAvailableMethods);
  const createIntent = usePaymentStore((s) => s.createIntent);
  const confirmPayment = usePaymentStore((s) => s.confirmPayment);
  const fetchPaymentHistory = usePaymentStore((s) => s.fetchPaymentHistory);
  const setStep = usePaymentStore((s) => s.setStep);
  const setSelectedProvider = usePaymentStore((s) => s.setSelectedProvider);
  const clearIntent = usePaymentStore((s) => s.clearIntent);
  const clearError = usePaymentStore((s) => s.clearError);
  const reset = usePaymentStore((s) => s.reset);

  return {
    availableMethods,
    currentIntent,
    paymentHistory,
    step,
    selectedProvider,
    isLoading,
    error,
    fetchAvailableMethods,
    createIntent,
    confirmPayment,
    fetchPaymentHistory,
    setStep,
    setSelectedProvider,
    clearIntent,
    clearError,
    reset,
  };
};
